import { render } from "./VaBeneIngredientTypeListPage.vue?vue&type=template&id=2b7e8194&ts=true"
import script from "./VaBeneIngredientTypeListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneIngredientTypeListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__